export default __webpack_public_path__ + "static/media/(20).bfea1ccb.jpeg";